import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-kpx.jpg");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-process-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-process-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-process-m-1.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-process-m-2.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-supply-en-arrow-m.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-supply-en-arrow.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-supply-gray-icon.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-supply-legacy-arrow.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/img-supply-purple-icon.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/section4_step3_mobile.png");
;
import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/assets/images/pages/pvdr/section4_step3_pc.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Divider/Divider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Stack/Stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/.pnpm/@mui+material@7.3.6_@emotion+react@11.14.0_@types+react@19.1.2_react@19.1.4__@emotion+styled@_aflsgygq4o45qk42pd5b33hahu/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.3.8_@babel+core@7.28.5_@opentelemetry+api@1.9.1_babel-plugin-macros@3.1.0_react-dom@1_qju5jnn2ro242seicfecxp7w4q/node_modules/next/dist/client/image-component.js");
